import api from './api';

// Talks to /api/costing — runs the calc_ layer and reads back its results and
// exceptions. Version and site come from the x-budget-version-id / x-site-code
// headers (set by the api interceptor); no site selected = every site.
export const costingService = {
  // Procurement: implosion + procurement prices.
  runPricing: async () => (await api.post('/costing/run-pricing')).data,
  // Manufacturing: everything, ending at the finished-good cost.
  runFull: async () => (await api.post('/costing/run-full')).data,

  // { rows, exceptions, lastRun }
  getPricing: async () => (await api.get('/costing/pricing')).data,
  getFgCost: async () => (await api.get('/costing/fg')).data,
};

export default costingService;
